import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TenantLookupFormComponent } from '../../components/tenant-lookup-form/tenant-lookup-form.component';

@Component({
  selector: 'app-tenant-not-found',
  imports: [TenantLookupFormComponent],
  templateUrl: './tenant-not-found.component.html',
  styleUrl: './tenant-not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantNotFoundComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  protected readonly attemptedName = signal<string>('');
  protected readonly title = computed(() => 'Organisatie Niet Gevonden');
  protected readonly message = computed(() =>
    this.attemptedName()
      ? `De organisatie "${this.attemptedName()}" kon niet worden gevonden. Controleer de spelling en probeer het opnieuw.`
      : 'De opgegeven organisatie kon niet worden gevonden. Controleer de spelling en probeer het opnieuw.'
  );

  ngOnInit(): void {
    // Get attempted name from query params
    this.route.queryParams.subscribe((params) => {
      const attemptedName = params['attemptedName'];
      if (attemptedName) {
        this.attemptedName.set(attemptedName);
      }
    });
  }

  protected onLookupSuccess(tenantName: string): void {
    // Success! Reload page with tenant in URL
    window.location.href = `/${tenantName}/`;
  }

  protected onLookupError(tenantName: string): void {
    // Update attempted name for the message
    // Error is shown inline in the form component
    this.attemptedName.set(tenantName);
  }
}
